import { API_TIMEOUT_TIERS } from '#pplx/frontend/api-clients/core/utils.js';
import { getCheckEduInstitutionQueryKey } from '#pplx/frontend/apps/ask/queries/query-keys/academicKeys.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
import { academicClient } from '#pplx_generated/typespec/rest/academic/client.js';
const checkEduInstitution = async ({ reason, headers, }) => {
    try {
        const { data } = await academicClient.GET('/rest/academic/check-edu-institution', reason, {
            timeoutMs: API_TIMEOUT_TIERS.HIGH,
            headers,
        });
        return data;
    }
    catch (error) {
        logger.error('Failed to check institution', error);
        return null;
    }
};
export const useCheckEduInstitution = ({ reason, }) => {
    return useQuery({
        queryKey: getCheckEduInstitutionQueryKey(),
        queryFn: () => checkEduInstitution({ reason }),
    });
};
//# sourceMappingURL=useCheckEduInstitution.js.map